import { FC, ReactNode } from "react";
import { MessageThreadModel } from "../models/MessageThreadModel";


interface SidebarCompProps {
    close: () => void;
    children?: ReactNode;
}

const SidebarComp: FC<SidebarCompProps> = ({ close, children }) => (
    <div className="d-flex flex-column border w-100">
        <div className="mb-3">
            <button className=" border btn float-end me-2 mt-2 " onClick={close}><i className="bi bi-chevron-left fs-2"></i></button>
        </div>
        <div className="flex-grow-1 overflow-auto" >
            {children}
        </div>

    </div>
);

export default SidebarComp;